import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {NotificationProvider} from "./STCLibrary/NotificationSystem/NotificationContext";
import NotificationBar from "./STCLibrary/NotificationSystem/NotificationBar";
import {BrowserRouter as Router} from "react-router-dom";
import PageRoutes from "./View/Pages/PageRoutes/PageRoutes";
import './Constants/Constants.css'
import CookieConsentForm from './CookieConsentForm/CookieConsentForm';
import PortalFooter from './View/Pages/PortalFooter/PortalFooter';

function App() {

  return (
      <div className={'App'}>
        <CookieConsentForm/>
        {/* <div style={{flex: 1}}> */}
          <NotificationProvider>
              
              
                
                <div style={{flex: 1, position: 'relative'}}>
                  <NotificationBar/>
              <Router>
                <PageRoutes/>
              </Router>
                </div>
              
          </NotificationProvider>
          {/* </div> */}
          <PortalFooter/>
      </div>
  );
}

export default App;
